import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import {
  MatchChartOuter,
  CustomLegendContainer,
  CustomLegendInner,
  ColorDot,
  CustomLegendValue,
} from "./styles";

const MatchChart = (props) => {
  const data = [
    { name: "Matched", value: props?.data[0]?.matchedMenteesCount || 0 },
    {
      name: "Not yet matched",
      value: props?.data[0]?.unmatchedMenteesCount || 0,
    },
  ];
  const COLORS = ["#4285F4", "#FFC107"];

  const CustomLegend = () => (
    <CustomLegendContainer>
      {data.map((entry, index) => (
        <CustomLegendInner key={`legend-item-${index}`}>
          <ColorDot
            style={{
              backgroundColor: entry.name === "Matched" ? COLORS[0] : COLORS[1],
            }}
          ></ColorDot>
          <CustomLegendValue>{entry.name}</CustomLegendValue>
        </CustomLegendInner>
      ))}
    </CustomLegendContainer>
  );
  return (
    <MatchChartOuter>
      <ResponsiveContainer width={230} height={250}>
        <PieChart width={300} height={300}>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            innerRadius={70}
            outerRadius={110}
            fill="#8884d8"
            paddingAngle={0}
            labelLine={false}
            label={({
              cx,
              cy,
              midAngle,
              innerRadius,
              outerRadius,
              percent,
              value,
              index,
            }) => {
              const RADIAN = Math.PI / 180;
              const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
              const x = cx + radius * Math.cos(-midAngle * RADIAN);
              const y = cy + radius * Math.sin(-midAngle * RADIAN);
              const rectSize = 28;
              const labelOffset = rectSize / 2;
              return (
                <g>
                  <rect
                    x={x - labelOffset}
                    y={y - labelOffset}
                    width={rectSize}
                    height={rectSize}
                    fill="white"
                    rx={14}
                    ry={14}
                    stroke="#ccc"
                  />
                  <text
                    x={x}
                    y={y}
                    fill="#302F2F"
                    textAnchor="middle"
                    dominantBaseline="middle"
                    fontSize={14}
                    fontWeight="500"
                    fontFamily="Nunito Sans"
                  >
                    {value}
                  </text>
                </g>
              );
            }}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index]} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
      <CustomLegend />
    </MatchChartOuter>
  );
};

export default MatchChart;
